import { useCallback, useState } from 'react';
import { useAuth } from '@/modules/auth/useAuth';
import { getSupabase } from '@/lib/supabase';
import { buildReportInsert, type SubmitReportInput } from './moderation';

export {
  REPORT_REASONS,
  REPORT_REASON_LABEL,
  type ReportReason,
  type SubmitReportInput,
} from './moderation';

export const useReport = () => {
  const { user } = useAuth();
  const [submitting, setSubmitting] = useState(false);

  const submit = useCallback(
    async (input: SubmitReportInput): Promise<{ ok: boolean; error?: string }> => {
      if (!user) return { ok: false, error: 'Not logged in.' };
      const built = buildReportInsert(input, user.id);
      if (!built.ok) return { ok: false, error: built.error };
      const supabase = getSupabase();
      if (!supabase) return { ok: false, error: 'No connection.' };

      setSubmitting(true);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const db = supabase as any;
      const { error } = (await db.from('hottr_reports').insert(built.row)) as {
        error: { message: string } | null;
      };
      setSubmitting(false);
      if (error) return { ok: false, error: error.message };
      return { ok: true };
    },
    [user?.id],
  );

  return { submit, submitting };
};
